module.exports = __webpack_public_path__ + "img/pic_2.87e801d4.jpg";